// removed by extract-text-webpack-plugin
module.exports = {"grid-header":"grid-header","gridHeader":"grid-header","user-name":"user-name","userName":"user-name","table-container-wrapper":"table-container-wrapper","tableContainerWrapper":"table-container-wrapper","react-bs-table-bordered":"react-bs-table-bordered","reactBsTableBordered":"react-bs-table-bordered","table-body-wrapper":"table-body-wrapper","tableBodyWrapper":"table-body-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/users/usersGrid/style.scss
// module id = 1619
// module chunks = 0